import PagesIcon from '@atlaskit/icon/core/pages';
import React from 'react';

export const SvgNotes = () => (
  <PagesIcon label="" testId="ads-refreshed-icon" />
);
